import React, { useState, useContext, useEffect } from 'react'
import MainContext from '@/stores/stores'
import HeaderOne from "./HeaderOne";
import HeaderTwo from "./HeaderTwo";
import HeaderThree from "./HeaderThree";
import HeaderFour from "./HeaderFour";
import HeaderFive from "./HeaderFive";
import HeaderSix from "./HeaderSix";
import HeaderSeven from "./HeaderSeven"

const HeaderComponent: React.FC<any> = (props) => {
  const { headerInfo={} } = props
  const [isMobile, setIsMobile] = useState<boolean>(false)

  useEffect(() => {
    isModernPhone().then((isTrue: boolean) => {
      setIsMobile(isTrue)
    })
  }, [])
  const isModernPhone = async () => {
    // 新标准设备检测 API (Chrome 89+)
    let _navigator: any = navigator
    if (_navigator.userAgentData) {
      const { mobile, platform } = await _navigator.userAgentData.getHighEntropyValues(
        ['mobile', 'platform']
      );
      // Android/iOS 平台 + 移动标志
      if (mobile && ['Android', 'iOS'].includes(platform)) {
        const deviceMemory = _navigator.deviceMemory || 0;
        return deviceMemory <= 8; // 排除高性能平板
      }
    }
    
    // 降级处理：屏幕尺寸 + 用户代理验证
    const maxDimension = Math.max(window.screen.width, window.screen.height);
    return maxDimension < 1000 && /Mobile/i.test(_navigator.userAgent);
  }
  return (
    <>
      {
        headerInfo.style === 1 ? <HeaderOne headerInfo={headerInfo}/> : null
      }
      {
        headerInfo.style === 2 ? <HeaderTwo headerInfo={headerInfo}/> : null
      }
      {
        headerInfo.style === 3 ? <HeaderThree headerInfo={headerInfo}/> : null
      }
      {
        headerInfo.style === 4 ? <HeaderFour headerInfo={headerInfo}/> : null
      }
      {
        headerInfo.style === 5 ? <HeaderFive headerInfo={headerInfo}/> : null
      }
      {
        headerInfo.style === 6 ? <HeaderSix headerInfo={headerInfo}/> : null
      }
      {
        headerInfo.style === 7 ? <HeaderSeven headerInfo={headerInfo}/> : null
      }
    </>
  )
}
export default HeaderComponent
